export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/prev.f8d4df31.svg","height":43,"width":43,"blurWidth":0,"blurHeight":0};